import useSWR, { SWRConfiguration } from 'swr';
import { PaymentModuleKey } from '../types';

export interface Mandate {
    details: Record<string, any>;
    id: string;
    method: string;
    status: MandateStatus;
    signatureDate: string;
    createdAt: string;
}

export type MandateStatus = 'valid' | 'pending' | 'invalid';

export const mandateQuery = (module?: PaymentModuleKey) => (module ? `?module=${module}` : '');

export default function useMandates(slug?: string, options?: SWRConfiguration, module?: PaymentModuleKey) {
    const methods = useSWR<Mandate[]>(slug ? `connect/${slug}/mandate${mandateQuery(module)}` : null, null, options);

    return methods;
}
